import * as angular from 'angular';
import { mgoAngularWizard, PortfolioCodeUploadWizardContext } from '../custom';
import { PortfolioCodeAssignmentResource } from 'app/_resources/portfolio-code.resource';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { BalancingAndPortfolioUploadWizardService } from 'app/_services/balancing-and-portfolio-upload-wizard.service';

class PortfolioCodeUploadWizardGeneralComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<PortfolioCodeUploadWizardContext>;
    private originalPortfolioCodeName: string;
    private errorPreparingNextWizardStage: boolean;
    private submitting: boolean;

    constructor(
        private $location: ng.ILocationService,
        private $q: ng.IQService,
        private portfolioCodeAssignmentResource: PortfolioCodeAssignmentResource,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource,
        private balancingAndPortfolioUploadWizardService: BalancingAndPortfolioUploadWizardService
    ) {
        this.errorPreparingNextWizardStage = false;
        this.submitting = false;
    }

    $onInit(): void {
        if (this.wizardCtrl.context.currentPortfolioCode) {
            this.originalPortfolioCodeName = angular.copy(
                this.wizardCtrl.context.currentPortfolioCode.name
            );
        }

        if (!this.wizardCtrl.context.shippersWithAssignmentToTso) {
            this.loadShippersWithAssignmentToTso();
        }
    }

    private loadShippersWithAssignmentToTso() {
        this.TransmissionSystemOperator.assignedShippers(
            (res: TsoShipperAssignmentsDto[]) => {
                this.wizardCtrl.context.shippersWithAssignmentToTso = res;
                this.wizardCtrl.context.unselectedShippers = angular.copy(res);
                this.wizardCtrl.context.selectedShippers = [];
            }
        );
    }

    public submit(isValid: boolean): boolean {
        if (!isValid) {
            return false;
        }

        this.submitting = true;

        this.balancingAndPortfolioUploadWizardService
            .prepareNextWizardStage(
                this.wizardCtrl.context.shippersWithAssignmentToTso,
                this.originalPortfolioCodeName,
                this.wizardCtrl.context.currentPortfolioCode.name,
                'PORTFOLIO'
            )
            .then((res: BalancingGroupAssignmentDto | undefined) => {
                if (res && res.name) {
                    this.wizardCtrl.context.currentPortfolioCode = res;
                    (
                        this.wizardCtrl.context.currentPortfolioCode as any
                    ).$$exists = true;
                } else {
                    (
                        this.wizardCtrl.context.currentPortfolioCode as any
                    ).$$exists = false;
                }

                this.wizardCtrl.next();
            })
            .catch(() => (this.errorPreparingNextWizardStage = true))
            .finally(() => (this.submitting = false));

        return true;
    }

    public cancel(): void {
        this.$location.path('/uploads');
    }
}

angular.module('app').component('pkpPortfolioCodeUploadWizardGeneral', {
    controller: PortfolioCodeUploadWizardGeneralComponentCtrl,
    template:
        require('app/portfolio-code-upload-wizard/portfolio-code-upload-wizard-general.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
